<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>销售客户使用&nbsp;&nbsp;说明:</h5><br>
				<span>1、录入客户信息、可额外上传附件资料。</span><br>
				<span class="red">2、查询关键字:名称、电话 </span><br>

			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				<button @click="edit_mode">客户资料</button>
			</template>
			<template slot="pre_tan_button">
				<button @click="edit_mode">客户资料</button>
			</template>

		</pre-base>

		<editmode-tan ref="itemmode"></editmode-tan>

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue"),
			"editmode-tan": () => import("../base_tan/tan_car_img.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "sellclient",
					"title": "销售客户",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_sell_car_client',
					"upd_action": 'exp15_sell_car_client',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [
						{
							"name": "客户",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "电话",
							"val": "",
							"key": "c_phone",
							"type": "text",
							"class": "long1",
						}
					],
					"parm": [
						{
							"name": "客户姓名",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "客户电话",
							"val": "",
							"key": "c_phone",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "客户证件",
							"val": "",
							"key": "c_no",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "客户地址",
							"val": "",
							"key": "c_addr",
							"type": "text",
							"class": "long5",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "银行账号",
							"val": "",
							"key": "acc_num",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "开户行地址",
							"val": "",
							"key": "bank_addr",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "textareaedit",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "4"
						}
					],
					"parm_th": [
						{
						  "name": "序号"
						},
						{
						  "name": "客户姓名"
						},
						{
						  "name": "客户电话"
						},
						{
						  "name": "客户证件"
						},
						{
						  "name": "客户地址"
						},
						{
						  "name": "银行账号"
						},
						{
						  "name": "开户行地址"
						},
						{
						  "name": "备注"
						},
						{
						  "name": "资料上传"
						},
						{
						  "name": "状态"
						},
						{
						  "name": "修改人"
						},
						{
						  "name": "修改时间"
						}
					],
					"d_parm": [],
					"d_name": []

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			edit_mode: function() {

				let sheet_no = '',flag='';
				for (let i = 0; i < this.item.length; i++) {
					// console.log(this.item[i].key + '=' + this.item[i].val);
					if (this.item[i].key == 'c_name') {
						sheet_no = this.item[i].val;
					}
					if (this.item[i].key == 'flag') {
						flag = this.item[i].val;
					}
				}

				let o = {};
				o.title = '姓名';
				o.sheet_no = sheet_no;
				o.flag = flag;
				o.sel_action = 'exp_sell_car_clientfile';
				o.upd_action = 'exp15_sell_car_file';
				o.file_action = 'sell_car_info';
				o.p1 = 'selluser';
				o.p2 = sheet_no;

				o.list_action = '_base_userfile';

				let that = this;
				this.$nextTick(function() {
					that.$refs['itemmode'].showpop(o);
				});


			},



		}
	};
</script>
<style>
</style>